<!--倒计时组件,通过传入截止时间(时间戳)自动倒计时-->
<!--策略，倒计时只有在时间小于一天进行，大于一天不进行倒计时-->
<!--实现思路：后台服务器传来截止时间时间戳，-->
<template>
  <div class="count-down-container" v-show="show">
    <!--天数-->
    <!--如果天数大于1天则展示天数-->
    <div class="rest-time-box" v-if="days > '0'">
      <span>剩余</span>
      <div class="time-box day-box">{{ days }}</div>
      <span class="time-unit text-primary">天</span>
    </div>
    <!-- 天数小于一天则展示倒计时 -->
    <div class="not-day-box" v-else>
      具体认购截止时间，在券商账户查看
    </div>
  </div>
</template>

<script>
export default {
  name: "CountDown",
  props: {
    timeStr: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      days: "0",
      show: false,
      timer: null
    };
  },
  mounted() {
    this.handleTime();
  },
  methods: {
    handleTime() {
      //当前时间
      const curTime = Date.now();
      //后台传来的截止时间
      const endTime = new Date(this.timeStr.replace(/-/g, '/')).getTime() + 24 * 3600 * 1000 - 1000;
      //剩余时间
      const restTime = (endTime - curTime) / 1000;
      //剩余天数
      this.days = String(parseInt(restTime / (24 * 60 * 60)));

      this.show = true;
    }
  }
};
</script>

<style scoped lang="less">
@import "../style/mixins";
.count-down-container {
  display: flex;
  height: 0.44rem;
  flex-direction: row;
  align-self: center;

  .rest-time-box {
    display: flex;
    flex-direction: row;
    height: 0.44rem;
    font-weight: 500;
    font-size: 0.32rem;
    font-family: PingFangSC-Medium;
    align-items: center;

    .time-box {
      width: 0.36rem;
      height: 0.4rem;
      .theme-mixins(color, #FFFFFF, #121212);
      .theme-mixins(background, #323232, #D2D2D3);
      border-radius: 0.06rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .day-box {
      margin: 0 0.04rem;
      font-family: PingFangSC-Medium;
      font-size: 0.24rem;
      letter-spacing: 0;
      font-weight: 500;
    }
  }

  .not-day-box {
    font-size: .24rem;
    font-family: PingFangSC-Regular;
    letter-spacing: 0;
    .theme-mixins(color, #000000, #D2D2D3);
    margin-bottom: 0.12rem;
  }

  .time-unit {
    margin-left: 0.04rem;
    font-family: PingFangSC-Medium;
    font-size: 0.32rem;
    line-height: 0.44rem;
    letter-spacing: 0;
    font-weight: 500;
  }
}
</style>
